/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tb_TitleInputs */

const en_tb_title = /** @type {(inputs: Tb_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team build`)
};

const id_tb_title = /** @type {(inputs: Tb_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build bersama tim`)
};

/**
* | output |
* | --- |
* | "Team build" |
*
* @param {Tb_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tb_title = /** @type {((inputs?: Tb_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tb_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tb_title(inputs)
	return en_tb_title(inputs)
});